import { Component, Inject, LOCALE_ID } from '@angular/core'
import { CommonModule } from '@angular/common'
import { HttpClient } from '@angular/common/http'
import { FormGroup, FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms'
import { Programa } from '../../models/programa.model'
import { SispgService } from '../../services/sispg.service'
import { ProgramaVisualizarComponent } from '../programa-visualizar/programa-visualizar.component'
import { MatDialog, MatDialogModule } from '@angular/material/dialog'
import { MatAutocompleteModule } from '@angular/material/autocomplete'
import { MatSelectModule } from '@angular/material/select'
import { MatInputModule } from '@angular/material/input'
import { MatFormFieldModule } from '@angular/material/form-field'
import { Observable } from 'rxjs/internal/Observable'
import { map, startWith } from 'rxjs'
import { MatIconModule } from '@angular/material/icon'
import { MatExpansionModule } from '@angular/material/expansion'
import { MatTooltipModule } from '@angular/material/tooltip'
import { ProgramaNomePipe } from '../../pipes/programa-nome.pipe'
import { Meta, Title } from '@angular/platform-browser'
import { Unidade } from '../../models/unidade.model'
import { TranslationService } from '../../services/translation.service'
import { DisciplinaPrograma } from '../../models/disciplina-programa.model'
import { DocentePrograma } from '../../models/docente-programa.model'
import { environment } from 'src/environments/environment'

declare var gtag: Function

@Component({
  selector: 'app-programa-listar',
  imports: [
    CommonModule,
    MatDialogModule,
    MatFormFieldModule,
    MatAutocompleteModule,
    MatSelectModule,
    MatInputModule,
    MatIconModule,
    MatExpansionModule,
    MatTooltipModule,
    FormsModule,
    ReactiveFormsModule,
    ProgramaNomePipe
  ],
  templateUrl: './programa-listar.component.html',
  styleUrls: ['./programa-listar.component.scss']
})
export class ProgramaListarComponent {

  env = environment

  dados: Programa[] = []
  linhas: string[] = []
  programas: Programa[] = []
  areas: string[] = ['Ciências Agrárias', 'Ciências Biológicas', 'Ciências da Saúde', 'Ciências Exatas e da Terra', 'Ciências Humanas', 'Engenharias', 'Ciências Socias Aplicadas', 'Linguística, Letras e Artes', 'Multidisciplinar']
  niveis: string[] = ['Mestrado', 'Mestrado Profissional', 'Doutorado', 'Doutorado Profissional']
  cidades: string[] = []
  conceitos: string[] = []
  disciplinas: DisciplinaPrograma[] = []
  docentes: DocentePrograma[] = []

  form = new FormGroup({
    nomeCurso: new FormControl(''),
    linhaPesquisa: new FormControl(''),
    area: new FormControl(''),
    nivel: new FormControl(''),
    cidade: new FormControl(''),
    conceito: new FormControl(''),
    disciplina: new FormControl(''),
    docente: new FormControl(''),
  })

  linhaPesquisaFiltered: Observable<string[]> | undefined
  disciplinaFiltered: Observable<string[]> | undefined
  docenteFiltered: Observable<string[]> | undefined

  localesList = [
    { path: '../en/programas/', label: 'English', image: 'assets/icons/locale-en.png' },
    { path: '../pt/programas/', label: 'Português - Brasil', image: 'assets/icons/locale-pt.png' }
  ]

  loadFail: boolean = false
  conceitosCapes = new Map<string, string>()

  constructor(
    @Inject(LOCALE_ID) public locale: string,
    private sispgService: SispgService,
    private http: HttpClient,
    private translationService: TranslationService,
    private meta: Meta,
    private title: Title,
    public dialog: MatDialog,
  ) {
    this.ajustaTagsHtml()
    this.ajustaTextos()
    this.carregaConceitosCapes()
    this.sispgService.programas(this.locale).subscribe({
      next: data => {
        this.dados = data
        this.programas = data
        this.programas.forEach(programa => {
          programa.unidades.forEach(unidade => {
            this.ajustaUnidade(unidade)
            if (this.cidades.indexOf(unidade.cidade) === -1) {
              this.cidades.push(unidade.cidade)
            }
          })
          if (programa.linhas) {
            for (let i = 0; i< programa.linhas.length; i++) {
              programa.linhas[i] = programa.linhas[i].replace('\r\n', '')
            }
            programa.linhas.forEach(linha => {
              if (this.linhas.indexOf(linha) === -1) {
                this.linhas.push(linha)
              }
            })
          }
          this.ajustaNiveis(programa)
        })
        this.cidades.sort()
        this.linhas.sort()
        this.linhaPesquisaFiltered = this.form.controls.linhaPesquisa.valueChanges.pipe(
          startWith(''),
          map(value => {
            if (value) {
              const pesquisa = (value as string).trim().toString().normalize('NFD').replace(/\p{Diacritic}/gu, '').toLowerCase()
              return this.linhas.filter(linha => linha.toLowerCase().normalize('NFD').replace(/\p{Diacritic}/gu, '').includes(pesquisa)).slice(0, 100)
            } else {
              // return this.linhas.slice() // retorna a lista para que a pessoa possa escolher
              return [] // a lista está em branco e só após digitar será apresetando a lista já com o filtro digitado
            }
          })
        )
      },
      error: (err) => {
        this.loadFail = true
      },
    })
    this.sispgService.disciplinasPrograma(this.locale).subscribe(data => {
      this.disciplinas = data
      // 
      this.disciplinaFiltered = this.form.controls.disciplina.valueChanges.pipe(
        startWith(''),
        map(value => {
          if (value) {
            const pesquisa = (value as string).trim().toString().normalize('NFD').replace(/\p{Diacritic}/gu, '').toLowerCase()
            return this.disciplinas.filter(disciplina => disciplina.nome.toLowerCase().normalize('NFD').replace(/\p{Diacritic}/gu, '').includes(pesquisa)).map(d => d.nome).slice(0, 100)
          } else {
            // return this.linhas.slice() // retorna a lista para que a pessoa possa escolher
            return [] // a lista está em branco e só após digitar será apresetando a lista já com o filtro digitado
          }
        })
      )
    })
    this.sispgService.docentesPrograma(this.locale).subscribe(data => {
      this.docentes = data
      // 
      this.docenteFiltered = this.form.controls.docente.valueChanges.pipe(
        startWith(''),
        map(value => {
          if (value) {
            const pesquisa = (value as string).trim().toString().normalize('NFD').replace(/\p{Diacritic}/gu, '').toLowerCase()
            return this.docentes.filter(docente => docente.nome.toLowerCase().normalize('NFD').replace(/\p{Diacritic}/gu, '').includes(pesquisa)).map(d => d.nome).slice(0, 100)
          } else {
            // return this.linhas.slice() // retorna a lista para que a pessoa possa escolher
            return [] // a lista está em branco e só após digitar será apresetando a lista já com o filtro digitado
          }
        })
      )
    })
  }

  conceitoCapes(programa: Programa): string | undefined {
    return this.conceitosCapes.get(programa.codigoCapes?.trim())
  }

  private carregaConceitosCapes(): void {
    this.http.get('assets/codigos-capes-conceitos.csv', { responseType: 'text' }).subscribe({
      next: csv => {
        this.conceitosCapes = this.interpretaCsvConceitos(csv)
        this.conceitos = [...new Set(this.conceitosCapes.values())].sort((a, b) => Number(a) - Number(b))
      }
    })
  }

  private interpretaCsvConceitos(csv: string): Map<string, string> {
    const conceitos = new Map<string, string>()
    const linhas = csv.replace(/^\uFEFF/, '').split(/\r?\n/).filter(linha => linha.trim())

    for (const linha of linhas.slice(1)) {
      const [codigoCapes, conceito] = linha.split(',').map(valor => valor.trim())
      if (codigoCapes && conceito) {
        conceitos.set(codigoCapes, conceito)
      }
    }

    return conceitos
  }

  pesquisar(): void {
    const nomeCurso = this.form.controls.nomeCurso.getRawValue()!.trim().toLowerCase().normalize('NFD').replace(/\p{Diacritic}/gu, '')
    const linhaPesquisa = this.form.controls.linhaPesquisa.getRawValue()!
    const area = this.form.controls.area.getRawValue()!
    const nivel = this.form.controls.nivel.getRawValue()!
    const cidade = this.form.controls.cidade.getRawValue()!
    const conceito = this.form.controls.conceito.getRawValue()!
    const disciplina = this.form.controls.disciplina.getRawValue()!
    const disciplinaPrograma = this.disciplinas.filter(d => d.nome == disciplina)
    const docente = this.form.controls.docente.getRawValue()!
    const docentePrograma = this.docentes.filter(d => d.nome == docente)
    this.programas = this.dados
      .filter(programa => programa.nome.toLowerCase().normalize('NFD').replace(/\p{Diacritic}/gu, '').includes(nomeCurso)
        && ( linhaPesquisa == '' || (programa.linhas != null &&  programa.linhas.some(v => v == linhaPesquisa)) )
        && ( area === '' || programa.area.toLowerCase() === area.toLowerCase() )
        && ( nivel === '' || programa.niveis.some(v => v == nivel) )
        && ( cidade === '' || programa.unidades.some(v => cidade == v.cidade) )
        && ( conceito === '' || this.conceitoCapes(programa) === conceito )
        && ( !disciplinaPrograma.length || disciplinaPrograma[0].idPrograma.includes(programa.id.toString()) )
        && ( !docentePrograma.length || docentePrograma[0].idPrograma.includes(programa.id.toString()) )
      )
  }

  validarFiltroLinhaPesquisa(): void {
    const valorNoInput = this.form.controls.linhaPesquisa.getRawValue()
    if (!this.linhas.includes(valorNoInput!)) {
      this.form.controls.linhaPesquisa.setValue('')
      this.pesquisar()
    }
  }

  validarFiltroDisciplina(): void {
    const valorNoInput = this.form.controls.disciplina.getRawValue()
    const filtered = this.disciplinas.filter(d => d.nome == valorNoInput)
    if (!filtered.length) {
      this.form.controls.disciplina.setValue('')
      this.pesquisar()
    }
  }

  validarFiltroDocente(): void {
    const valorNoInput = this.form.controls.docente.getRawValue()
    const filtered = this.docentes.filter(d => d.nome == valorNoInput)
    if (!filtered.length) {
      this.form.controls.docente.setValue('')
      this.pesquisar()
    }
  }

  selecionarLinhaPesquisa(value: string): void {
    this.form.controls.linhaPesquisa.setValue(value)
    this.pesquisar()
  }

  selecionarDisciplina(value: string): void {
    this.form.controls.disciplina.setValue(value)
    this.pesquisar()
  }

  selecionarDocente(value: string): void {
    this.form.controls.docente.setValue(value)
    this.pesquisar()
  }

  limpar(field: string): void {
    this.form.get(field)?.setValue('')
    this.pesquisar()
  }

  openDialog(programa: Programa): void {
    this.event('select_program', {
      program_name: programa.nome,
      program_level: programa.niveis.join(', '),
      program_school: programa.unidades.map(u => u.nome).join(', '),
      source: 'program_list',
    })
    this.dialog.open(ProgramaVisualizarComponent, {data: programa, width: '90%'})
  }

  ajustaTagsHtml() {
    if (this.locale === 'en') {
      this.title.setTitle(this.translationService.translateTitle(this.locale))
      this.meta.updateTag({ name: 'description', content: this.translationService.translateDescription(this.locale) })
    }
  }

  ajustaTextos() {
    if (this.locale === 'en') {
      this.areas = this.translationService.translateAreas(this.locale)
      this.niveis = this.translationService.translateNiveis(this.locale)
    }
  }

  ajustaUnidade(unidade: Unidade) {
    if (this.locale === 'en') {
      unidade.nome = this.translationService.translateUnidade(unidade.nome, this.locale)
    }
  }

  ajustaNiveis(programa: Programa) {
    if (this.locale === 'en') {
      this.translationService.ajustaNiveisEnUs(programa)
    }
  }

  private event(eventName: string, params: Record<string, any> = {}) {
    if (this.env.tag === 'PROD' && typeof gtag === 'function') {
      gtag('event', eventName, params)
    }
  }
}
